<template>
  <div class="ma-0 pa-0 mt-n10">
    <v-container>
      <div>
        <v-row>
          <v-col cols="8">
            <v-row>
              <CRUDList class="mt-10" :canAdd="false"
              :canEdit="false" :canSave="false"
              :enableFixedHeaders="true" :displayTopPagination="false"
              :headers="headers" :baseCrudKey="baseCrudKeyForDTable"
              tableWrapperDynamicClassname='elevation-3 ma-3 pt-0 pa-1 taxroll-table-wrapper'
              tableDynamicClassname='taxroll-custom-table' tableDynamicHeight='300'
              :headersWithColsSpan="headersWithColsSpan" :defaultSortBy="defaultSortBy"
              :loadingData="gridLoading.flag"
              :loadingText="gridLoading.text"
              @loadCRUDList = "loadAssesorDataHandlder">
            </CRUDList>
            <v-col cols="6" class="ma-0 pt-0 pb-0 mt-n3">
              <p class="">Preview Tax Record</p>
            </v-col>
            <v-col cols="3" class="ma-0 pa-0 mt-n7">
              <v-checkbox label="Show Errors Only" class="input-text-size"
              @change="loadAssesorDataHandlder" v-model="criteriaState.showErrorsOnly" />
            </v-col>
            <v-col cols="3" class="ma-0 pa-0 mt-n7">
              <v-checkbox label="Show SA Only" class="input-text-size"
              @change="loadAssesorDataHandlder" v-model="criteriaState.showSAOnly" />
            </v-col>
            <v-col cols="4" class="ma-0 pt-0 pb-0 mt-n2">
              <v-textarea class="input-text-size pa-0  mt-n1 dec-line-height" outlined rows="9"
              label="Owner Info Consolidated View" :value="handleConsolidateView()" readonly />
            </v-col>
            <v-col cols="4" class="ma-0 pt-0 pb-0 mt-n2">
              <p class="input-text-size mb-n1">Parcel Id: {{ formatToPidWithDashes() }}</p>
              <p class="input-text-size mb-n1 pt-1">
                Situs Address: {{ getItemItem.situsAddress }}</p>
              <v-textarea class="input-text-size pt-2 dec-line-height"
               v-model="getItemItem.legalDesc" outlined rows="4"
               label="Legal Description" readonly />
            </v-col>
            <v-col cols="4" class="ma-0 pt-0 pb-0 mt-n2">
              <p class="input-text-size mb-n1">Land Value: {{ getItemItem.land || null }}</p>
              <p class="input-text-size mb-n1 pt-1">Improvement Value:
                {{ getItemItem.improvements || null }}</p>
              <p class="input-text-size mb-n1 pt-1">Mobile Home Value:
                {{ getItemItem.mobileHome || null }}</p>
              <p class="input-text-size mb-n1 pt-1">Penalty Value: {{ getItemItem.assessorPenalty
              || null }}</p>
              <p class="input-text-size mb-n1 pt-1">Exemptions:
                 {{ getItemItem.exemptions || null }}</p>
            </v-col>
          </v-row>
          </v-col>
          <v-col cols="4">
            <p class="input-text-size mt-8 mb-n1">New Tax Year: {{ newTaxYear }}</p>
            <v-row no-gutters align="center">
              <v-col cols="9">
                <v-select
                  v-model="selectedLandmarkFile"
                  :items="landmarkFtpFiles"
                  item-text="label"
                  item-value="name"
                  label="Select Landmark FTP File"
                  :loading="landmarkFtpLoading"
                  clearable
                  dense
                  outlined
                  class="input-text-size mt-2"
                  hide-details
                />
              </v-col>
              <v-col cols="3" class="text-center">
                <v-btn class="input-text-size mt-2" text color="blue darken-1"
                  :loading="unzipLoading" :disabled="unzipLoading" @click="unzipFtpFile">
                  Unzip
                </v-btn>
              </v-col>
            </v-row>
            <UploadToBackend ref="uploadToBackend"
            profileName="Select Assesor Profile" :folderName="folderName"
            :profileItem="assesorListItem" @loadCRUDList="fromUploadToBackend" />
            <v-row align="center">
              <v-col cols="6">
                <h3 class="input-text-size mb-n4">Total Records in File</h3>
              </v-col>
              <v-col cols="6">
                <v-text-field hide-details rows="1" label=""
                v-model="assesorTotalData.totalRecords"
                readonly class="input-text-size py-0 my-0" />
              </v-col>
            </v-row>
            <v-row align="center" class="my-0">
              <v-col cols="6">
                <h3 class="input-text-size mb-n4">Total Tax Amount</h3>
              </v-col>
              <v-col cols="6">
                <v-text-field hide-details rows="1" label=""
                 :value="getTotalTaxAmount()"
                readonly class="input-text-size py-0 my-0" />
              </v-col>
            </v-row>
            <v-row align="center" class="my-n2">
              <v-col cols="6">
                <h3 class="input-text-size mb-n4">Records with Errors</h3>
              </v-col>
              <v-col cols="6">
                <v-text-field hide-details rows="1" label=""
                v-model="assesorTotalData.totalRecordsWithError"
                readonly class="input-text-size py-0 my-0" />
              </v-col>
            </v-row>
            <!-- Tulsa only: the Assessor file carries the subdivision NAME, so the conversion
            keeps the shared Additions list up to date from it. Hidden for counties whose file
            sends only the code - nothing is synced for them. -->
            <v-row align="center" class="my-n2" v-if="additionSync">
              <v-col cols="6">
                <h3 class="input-text-size mb-n4">Additions Created / Updated</h3>
              </v-col>
              <v-col cols="6">
                <!-- this readonly field is only ~174px wide, so it holds just the two numbers;
                the sentence underneath has the full width to spell them out -->
                <v-text-field hide-details rows="1" label=""
                :value="additionSyncCounts"
                readonly class="input-text-size py-0 my-0" />
              </v-col>
            </v-row>
            <v-row v-if="additionSync" class="my-n2">
              <v-col cols="12">
                <p class="input-text-size mb-1">
                  Shared Additions list updated from the Assessor file:
                  {{ additionSyncDetail }}
                </p>
              </v-col>
            </v-row>
            <v-row v-if="additionSyncChangedCodes" class="my-n2">
              <v-col cols="12">
                <p class="input-text-size mb-1">
                  Descriptions taken from the Assessor file for:
                  {{ additionSyncChangedCodes }}
                </p>
              </v-col>
            </v-row>
            <v-row v-if="additionSyncConflictCodes" class="my-n2">
              <v-col cols="12">
                <p class="input-text-size mb-1 red--text">
                  Sent under more than one subdivision name - longest kept, please review:
                  {{ additionSyncConflictCodes }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-btn small text color="blue darken-1" @click="printErrorsList">
                  Print Error List
                </v-btn>
                <v-btn small text color="blue darken-1" @click="printAdvancedTax">
                  Print Advanced Tax
                </v-btn>
                <v-btn small text color="blue darken-1" @click="printAbstract">
                  Print Abstract
                </v-btn>
                <v-checkbox label="Original Tax Districts" class="input-text-size mt-n1"
                 v-model="showOriginalTaxDistrictsFlag" />
              </v-col>
              <v-col cols="6">
                <v-btn small text color="blue darken-1" @click="rollComments">
                  Roll Comments
                </v-btn>
                <v-btn small text color="blue darken-1" @click="rollMtgCodes">
                  Roll Mortgage Codes
                </v-btn>
                <v-btn small text color="blue darken-1" @click="rollStatusCodes">
                  Roll Status Codes
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <template>
        </template>
      </div>
    </v-container>
  </div>
</template>
<script>

import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import { newTaxRollHeaders, newTaxRollMainHeaders } from '../../../shared/Utils/taxHeaders.utils';
import UploadToBackend from '../../../common/import/NewTaxRollUploadToBackend.vue';
import { commonFuncForFilterMtgCoProc, makeCriteriaStateNullIfEmptyString } from '../../common-utils/CommonTaxFunctionalities';
import { assesorList } from './SpecialTaxItems.utils';
import {
  amountFormat, defaultGridLoading, manageGridLoading, pIdFormat, zipFormat,
} from '../../../../util/shared/vue-global';
import { folderNameForUploadToBackend, getTaxYearStatus } from '../../common-utils/tax-common.util';
import { generateQueryString } from '../../../common/base/report/report-util';
import { clients } from '../../../../util/clients';
import '../../../../assets/style.css';

const { backendRest } = clients.direct;
export default {
  name: 'ImportAndBalance',
  data() {
    return {
      baseCrudKey: 'assesorList',
      baseCrudKeyForDTable: 'assesorList-data',
      baseCrudKeyForTotal: 'baseCrudKeyForTotal',
      selProfileName: '',
      headers: newTaxRollHeaders,
      uploadFileNameUI: undefined,
      canUpload: true,
      headersWithColsSpan: newTaxRollMainHeaders,
      assesorListItem: assesorList,
      gridLoading: defaultGridLoading(),
      newTaxYear: null,
      folderName: folderNameForUploadToBackend.newTaxRoll,
      showOriginalTaxDistrictsFlag: false,
      landmarkFtpFiles: [],
      selectedLandmarkFile: null,
      landmarkFtpLoading: false,
      unzipLoading: false,
    };
  },
  created() {
    this.loadLandmarkFtpFiles();
    this.loadConfig({ requiredScope: 'taxConfig' });
    this.loadAssessorFireTaxXRefRecords({
      baseCrudKey: 'assessorFireTaxXRefDropDown',
      criteria: {
        sortBy: [{ column: 'fireDistrict', direction: 'desc' }],
      },
    });
    this.loadAssesorTaxTotalHandler();
  },
  components: {
    CRUDList,
    UploadToBackend,
  },
  computed: {
    ...mapGetters('base/crud', [
      'items',
      'item',
      'criteria',
    ]),
    ...mapState({
      assesorTotalData: (state) => state.tax.newTaxroll.assesorTotalData,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
    }),
    defaultSortBy() {
      return [
        {
          column: 'taxId',
          direction: 'desc',
        },
      ];
    },
    // Null until a conversion whose file names its subdivisions has run.
    additionSync() {
      return (this.assesorTotalData || {}).additionSync || null;
    },
    // Kept to two numbers so it never overflows the narrow readonly field.
    additionSyncCounts() {
      const sync = this.additionSync;
      if (!sync) return '';
      return `${sync.createdCount || 0} / ${sync.updatedCount || 0}`;
    },
    additionSyncDetail() {
      const sync = this.additionSync;
      if (!sync) return '';
      return `${sync.createdCount || 0} created, ${sync.updatedCount || 0} updated,`
        + ` ${sync.unchangedCount || 0} already correct.`;
    },
    // The counts are always exact; the code lists can be capped, so say when they are.
    additionSyncChangedCodes() {
      const sync = this.additionSync;
      if (!sync || !sync.updatedCount) return '';
      return this.formatAdditionCodeList(sync.updated, sync.updatedCount);
    },
    additionSyncConflictCodes() {
      const sync = this.additionSync;
      if (!sync || !sync.conflictCount) return '';
      return this.formatAdditionCodeList(sync.conflicts, sync.conflictCount);
    },
    getData() {
      return this.items('transform-mapper-list');
    },
    getItemItem() {
      return this.item(this.baseCrudKeyForDTable);
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKeyForDTable);
      },
      set(value) {
        this.setCriteria([this.baseCrudKeyForDTable, value]);
      },
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('tax/MortgageCoProcessing', [
      'setPipeline',
    ]),
    ...mapActions(['reAuth', 'flashSuccess', 'flashError', 'flashInfo']),
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapMutations('base/crud', ['setCriteria', 'setItem', 'setItems']),
    ...mapActions('tax/newTaxroll', ['loadAssesorTax', 'loadAssesorTaxTotal', 'accessorRollTheComments', 'accessorRollTheMtgCode',
      'accessorRollTheStatusCode', 'loadAssessorFireTaxXRefRecords',
    ]),
    async loadLandmarkFtpFiles() {
      this.landmarkFtpLoading = true;
      try {
        await this.reAuth();
        const { data } = await backendRest.get('/landmark/ftp/files');
        this.landmarkFtpFiles = Array.isArray(data) ? data : [];
      } catch (e) {
        this.flashError('Failed to load Landmark FTP files.');
      } finally {
        this.landmarkFtpLoading = false;
      }
    },
    /* Pulls the selected archive off the Landmark FTP and expands it on the backend,
       flat and archive-prefixed, straight into this screen's own upload folder
       (targetFolder) - so the extracted files land in the same list as anything
       uploaded through the file input and import/delete out of one directory.
       Downloading and unzipping a full taxroll takes a while, so the button spins and
       stays disabled until the Uploaded files list underneath has been refreshed -
       that refresh is the point of the whole operation, so it is awaited here rather
       than left to the child to notice. */
    async unzipFtpFile() {
      if (!this.selectedLandmarkFile) {
        this.flashInfo('Please select a Landmark FTP file to unzip.');
        return;
      }
      this.unzipLoading = true;
      try {
        await this.reAuth();
        await backendRest.get('/landmark/ftp/extractfiles', {
          params: { fileName: this.selectedLandmarkFile, targetFolder: this.folderName },
        });
        await this.$refs.uploadToBackend.getFileListMethod();
        this.flashSuccess('Successfully unzipped FTP files.');
      } catch (e) {
        this.flashError('Failed to unzip Landmark FTP files.');
      } finally {
        this.unzipLoading = false;
      }
    },
    onAccessorDropDownChange(val) {
      const itemData = this.items('transform-mapper-list');
      const selProName = (this.assesorListItem || []).filter((dt) => dt.value === val);
      this.selProfileName = selProName.length ? selProName[0].name : '';
      const { filteredTaxItemData } = commonFuncForFilterMtgCoProc(itemData, 'Assessor File');
      const [filtTaxData] = filteredTaxItemData.filter((ft) => ft.name === val);
      this.setPipeline(filtTaxData || {});
    },
    fromUploadToBackend() {
      this.loadAssesorDataHandlder();
      this.loadAssesorTaxTotalHandler();
    },
    loadAssesorDataHandlder() {
      manageGridLoading(this, true, 'Searching...');
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      const criteria = {
        ...this.criteriaState,
      };
      this.loadAssesorTax({
        criteria,
        baseCrudKey: this.baseCrudKeyForDTable,
        postProcessTrans: this.protestTaxPostProcessTrans,
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    loadAssesorTaxTotalHandler() {
      this.loadAssesorTaxTotal({
        baseCrudKey: this.baseCrudKeyForTotal,
      });
      const { currentTax } = getTaxYearStatus();
      this.newTaxYear = currentTax || (this.latestTaxYear + 1) || null;
    },
    getTotalTaxAmount() {
      return amountFormat(this.assesorTotalData.totalTaxAmount);
    },
    // Keeps the line readable on a big roll without ever implying the list is complete when the
    // backend capped it.
    formatAdditionCodeList(entries, total) {
      const codes = (entries || []).map((entry) => entry.code);
      const shown = codes.slice(0, 20).join(', ');
      const hidden = (total || codes.length) - Math.min(codes.length, 20);
      return hidden > 0 ? `${shown} and ${hidden} more` : shown;
    },
    handleConsolidateView() {
      const editedItem = this.getItemItem;
      const arrOfKeysOwner = ['ownerId'];
      const arrOfKeysOne = ['name1', 'name2'];
      const arrOfKeysTwo = ['inCareOf1', 'inCareOf2'];
      const arrOfKeysThree = ['address1', 'address2', 'address3', 'address4'];
      const arrOfKeysFour = ['city', 'state', 'zip'];

      // get owner id
      const ownerId = arrOfKeysOwner
        .map((ft) => (editedItem[ft] && editedItem[ft].trim()) || '')
        .filter(Boolean);

      // Step 1: Names
      const val1 = arrOfKeysOne
        .map((ft) => (editedItem[ft] && editedItem[ft].trim()) || '')
        .filter(Boolean);

      // Step 2: In-care-of, first one gets C/O
      const val2 = arrOfKeysTwo
        .map((ft) => (editedItem[ft] && editedItem[ft].trim()) || '')
        .filter(Boolean)
        .map((line, index) => (index === 0 ? `C/O ${line}` : line));

      // Step 3: Addresses
      const val3 = arrOfKeysThree
        .map((ft) => (editedItem[ft] && editedItem[ft].trim()) || '')
        .filter(Boolean);

      // Step 4: City + State + ZIP merged
      let val4 = arrOfKeysFour
        .map((ft, i) => (i === 2 ? zipFormat(editedItem[ft]) : (editedItem[ft] && editedItem[ft].trim()) || ''))
        .filter(Boolean);
      val4 = [val4.join(' ')]; // Merge into one line

      const val5 = editedItem.country ? [editedItem.country] : [];

      // Combine all
      const allLines = [...ownerId, ...val1, ...val2, ...val3, ...val4, ...val5];
      return allLines.join('\n');
    },
    formatToPidWithDashes() {
      // if there is no propertyOrParcelId, return empty string
      if (!this.getItemItem.propertyOrParcelId) return '';

      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const formattedPid = pIdFormat(this.getItemItem.propertyOrParcelId, formatPidPositions);
      return formattedPid;
    },
    async rollComments() {
      const accessorRollTheComments = await this.accessorRollTheComments();
      if (accessorRollTheComments.statusCode === 200) {
        this.flashSuccess('Comments rolled successfully.');
      } else {
        this.flashError('There was a problem rolling the comments.');
      }
    },
    async rollMtgCodes() {
      const accessorRollTheMtgCode = await this.accessorRollTheMtgCode();
      if (accessorRollTheMtgCode.statusCode === 200) {
        this.flashSuccess('Mortgage codes rolled successfully.');
      } else {
        this.flashError('There was a problem rolling the mortgage codes.');
      }
    },
    async rollStatusCodes() {
      const accessorRollTheStatusCode = await this.accessorRollTheStatusCode();
      if (accessorRollTheStatusCode.statusCode === 200) {
        this.flashSuccess('Status codes rolled successfully.');
      } else {
        this.flashError('There was a problem rolling the status codes.');
      }
    },
    async printAbstract() {
      const { jwt } = await this.reAuth();
      const params = [
        `token=${jwt}`,
        `isItOriginalTaxDistrict=${this.showOriginalTaxDistrictsFlag}`,
      ];
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/newTaxRoll/abstract${queryString}`;
      window.open(url, '_blank');
    },
    async printAdvancedTax() {
      const { jwt } = await this.reAuth();
      const params = [
        `token=${jwt}`,
      ];
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/newTaxRoll/advanceTax${queryString}`;
      window.open(url, '_blank');
    },
    async printErrorsList() {
      const { jwt } = await this.reAuth();
      const params = [
        `token=${jwt}`,
      ];
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/newTaxRoll/errorsList${queryString}`;
      window.open(url, '_blank');
    },
  },
  // watch: {
  //   latestTaxYear(newVal) {
  //     this.newTaxYear = newVal + 1 || null;
  //   },
  // },
};
</script>
